import React, { useState } from 'react'
import Autosuggest from 'react-autosuggest'
import {
    AutocompleteItems,
    AutocompleteComponentType,
    GetAutocompleteSuggestion
} from '../../../typings/components'
import { useField } from 'formik'

const Autocomplete: React.FC<AutocompleteComponentType> = ({ onChange, placeholder, name, id }) => {
    const [value, setValue] = useState('')
    const [suggestions, setSuggestions] = useState<AutocompleteItems[]>([])
    const [field, meta, helpers] = useField(name)

    const getSuggestions = (
        value: string,
        onChangeEvent: GetAutocompleteSuggestion
    ): AutocompleteItems[] => {
        return onChangeEvent(value)
    }

    const getSuggestionValue = (suggestion: AutocompleteItems): string => {
        helpers.setValue(suggestion.value)
        return suggestion.text
    }

    const onChangeAutocomplete = (event, { newValue }): void => {
        setValue(newValue)
    }

    const shouldRenderSuggestions = (value): boolean => {
        return value.trim().length > -1
    }

    const onSuggestionsFetchRequested = ({ value }): void => {
        if (shouldRenderSuggestions(value)) {
            setSuggestions(getSuggestions(value, onChange))
        }
    }

    const onSuggestionsClearRequested = (): void => {
        setSuggestions([])
    }

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
        placeholder: placeholder,
        value,
        onChange: onChangeAutocomplete,
        name: name,
        className: 'form-control',
        required: true
    }

    const renderSuggestion = (suggestion: AutocompleteItems): JSX.Element => {
        return <span className="form-control">{suggestion.text}</span>
    }

    const renderInputComponent = (inputProps): JSX.Element => (
        <div>
            <input {...inputProps} />
        </div>
    )

    return (
        <div>
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                renderInputComponent={renderInputComponent}
                inputProps={inputProps}
                id={id}
            />
        </div>
    )
}

export default Autocomplete
